/**
 * Contact Information Constants
 * Centralized contact details for Leal Chapa y Pintura
 */

export const CONTACT = {
  // Phone
  phone: {
    raw: '+34698925394',
    display: '(+34) 698 92 53 94',
    displayShort: '698 92 53 94',
    link: 'tel:+34698925394'
  },

  // WhatsApp
  whatsapp: {
    raw: '+34698925394',
    link: 'https://wa.me/+34698925394'
  },

  // Email
  email: {
    general: 'taller@lealchapaypintura.com',
    link: 'mailto:taller@lealchapaypintura.com'
  },

  // Address
  address: {
    street: 'C. Congreso, 57',
    area: 'Pol. P.I.S.A',
    city: 'Mairena del Aljarafe',
    province: 'Sevilla',
    postalCode: '41927',
    country: 'España',
    full: 'C. Congreso, 57, Pol. P.I.S.A, 41927 Mairena del Aljarafe, Sevilla',
    shortDisplay: 'C. Congreso, 57 | Pol. P.I.S.A',
    googleMapsLink: 'https://www.google.com/maps/place//data=!4m2!3m1!1s0xd126d27da03445b:0x4605fa9dd282f634'
  },

  // Business Hours
  hours: {
    weekdays: 'Lunes - Viernes: 7:00 - 15:00',
    saturday: 'Cerrado',
    sunday: 'Cerrado'
  },

  // Social Media
  social: {
    facebook: 'https://www.facebook.com/lealchapaypintura',
    instagram: 'https://www.instagram.com/lealchapaypintura',
    google: 'https://g.page/lealchapaypintura'
  }
};

export default CONTACT;
